import React from 'react'

import SvgIcon from '@material-ui/core/SvgIcon'
const Logo = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id='Capa_1'
        height='20'
        viewBox='0 0 512 512'
        width='20'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g>
          <path
            d='m120 316v-270l-30-30h-75c-8.291 0-15 6.709-15 15v300c0 8.291 6.709 15 15 15h75zm-60 0h-30v-60h30zm0-90h-30v-90h30zm-30-120v-60h30v60z'
            fill='#804040'
          />
          <path
            d='m497 16h-75l-31 30v270l31 30h75c8.291 0 15-6.709 15-15v-300c0-8.291-6.709-15-15-15zm-15 300h-30v-60h30zm0-90h-30v-90h30zm0-120h-30v-60h30z'
            fill='#633'
          />
          <path d='m256 16h-166v330h166 166v-330z' fill='#f25588' />
          <path d='m256 16h166v330h-166z' fill='#e63a57' />
          <g>
            <path
              d='m316 436c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z'
              fill='#bfd6ff'
            />
          </g>
          <g>
            <path
              d='m196 436c-8.291 0-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15v60c0 8.291-6.709 15-15 15z'
              fill='#d9e5ff'
            />
          </g>
          <g>
            <path
              d='m196 376c-24.814 0-45-20.186-45-45v-60c0-8.291 6.709-15 15-15h60c8.291 0 15 6.709 15 15v60c0 24.814-20.186 45-45 45z'
              fill='#ecf2ff'
            />
          </g>
          <g>
            <path
              d='m316 376c-24.814 0-45-20.186-45-45v-60c0-8.291 6.709-15 15-15h60c8.291 0 15 6.709 15 15v60c0 24.814-20.186 45-45 45z'
              fill='#d9e5ff'
            />
          </g>
          <path
            d='m286 106c-11.514 0-22.031 4.351-30 11.484-7.969-7.133-18.486-11.484-30-11.484-24.814 0-45 20.186-45 45 0 37.383 56.895 67.72 68.291 73.418 2.109 1.055 4.409 1.582 6.709 1.582s4.6-.527 6.709-1.582c11.396-5.698 68.291-36.035 68.291-73.418 0-24.814-20.186-45-45-45z'
            fill='#ecf2ff'
          />
          <path
            d='m331 151c0-24.814-20.186-45-45-45-11.514 0-22.031 4.351-30 11.484v108.516c2.3 0 4.6-.527 6.709-1.582 11.396-5.698 68.291-36.035 68.291-73.418z'
            fill='#d9e5ff'
          />
          <path
            d='m407 406h-151-151c-8.291 0-15 6.709-15 15v60h166 166v-60c0-8.291-6.709-15-15-15z'
            fill='#ffdf40'
          />
          <path
            d='m422 421c0-8.291-6.709-15-15-15h-151v75h166z'
            fill='#ffbe40'
          />
          <path
            d='m497 466h-241-241c-8.291 0-15 6.709-15 15s6.709 15 15 15h241 241c8.291 0 15-6.709 15-15s-6.709-15-15-15z'
            fill='#9af'
          />
          <path
            d='m512 481c0-8.291-6.709-15-15-15h-241v30h241c8.291 0 15-6.709 15-15z'
            fill='#8080ff'
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

export default Logo
